import type Shepherd from 'shepherd.js';

export default function getAvailabilityCalendarSteps(
    texts: StandardObjectInterface
): Shepherd.Step.StepOptions[] {
    return [
        {
            id: 'availability_step',
            title: texts.availability.title,
            text: texts.availability.description,
            attachTo: {
                element: '[data-tour="availability"]',
                on: 'bottom'
            },
            modalOverlayOpeningRadius: 20,
            modalOverlayOpeningPadding: 12,
            buttons: [
                {
                    text: texts.button.skip,
                    secondary: true,
                    classes: 'nh-button nh-button--secondary',
                    action(): void {
                        this.hide();
                    }
                },
                {
                    text: texts.button.next,
                    classes: 'nh-button nh-button--primary',
                    action(): void {
                        this.next();
                    }
                }
            ]
        },
        {
            id: 'configuration_step',
            title: texts.configuration.title,
            text: texts.configuration.description,
            attachTo: {
                element: '[data-tour="configuration"]',
                on: 'bottom'
            },
            modalOverlayOpeningRadius: 20,
            modalOverlayOpeningPadding: 12,
            buttons: [
                {
                    text: texts.button.back,
                    classes: 'shepherd-button-outlined nh-button nh-button--secondary',
                    action(): void {
                        this.back();
                    }
                },
                {
                    text: texts.button.complete,
                    classes: 'nh-button nh-button--primary',
                    action(): void {
                        this.complete();
                    }
                }
            ]
        }
    ];
}
